import React, { PureComponent } from 'react'
import { func } from 'prop-types'
import { Locale } from '@active/react-utils/i18n'
import noop from 'lodash/noop'
import BillingAddress from '../../common/BillingAddress'
import { paymentMethodPropType } from '../../common/paymentMethodTypes'
import SavedECheckEUDD from '../SavedECheckEUDD'
import './SavedECheckEUDDForm.scss'

class SavedECheckEUDDForm extends PureComponent {
  static propTypes = {
    getSavedECheckEUDDFormCallBack: func.isRequired,
    paymentMethod: paymentMethodPropType.isRequired,
    submitTrigger: func.isRequired,
  }

  submitBillingAddress = noop

  componentDidMount() {
    const { submitTrigger } = this.props
    submitTrigger(this.submitBillingAddress)
  }

  getBillingAddressCallBack = values => {
    const { paymentMethod, getSavedECheckEUDDFormCallBack } = this.props
    const updatePaymentMethod = { ...paymentMethod, ...values }
    if (values.errorCode !== 'BILLINGADDRESS_INVALID_PARAMS') {
      getSavedECheckEUDDFormCallBack(updatePaymentMethod)
    }
  }

  render() {
    const { paymentMethod, paymentMethod: { billingFirstName, billingLastName, address } } = this.props
    const billingAddressInfo = {
      billingFirstName,
      billingLastName,
      address,
    }
    return (
      <div className="checkout__save-ee checkout-ee">
        <h2 className="checkout__save-ee__title">
          <Locale id="passport.lib.components.payment.ecpeudd.title" />
        </h2>
        <SavedECheckEUDD paymentMethod={paymentMethod} />
        <BillingAddress
          getBillingAddressCallBack={this.getBillingAddressCallBack}
          defaultValues={billingAddressInfo}
          submitTrigger={submitBillingAddressFun => {
            this.submitBillingAddress = submitBillingAddressFun
          }}
        />
      </div>
    )
  }
}

export default SavedECheckEUDDForm
